import { render } from "./TimeSlotByDayChild.vue?vue&type=template&id=64bcb43a&scoped=true&ts=true"
import script from "./TimeSlotByDayChild.vue?vue&type=script&lang=ts"
export * from "./TimeSlotByDayChild.vue?vue&type=script&lang=ts"

import "./TimeSlotByDayChild.vue?vue&type=style&index=0&id=64bcb43a&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bcb43a"]])

export default __exports__